<template lang="pug">
a-modal(
    centered
    :visible="shownEmail"
    :title="LANG.MODEL_EMAIL_TITLE"
    :footer="false"
    @cancel="closePopup"
    class="popup-send-email"
    width="400px"
)
    a-spin(:spinning="spinning" v-if="!send_status")
        div.mb-1
            span(style="font-size: 18px") {{ LANG.MODEL_EMAIL }}
            span(style="color:red") *
        div
            input(
                class="input-email"
                @focus="showEmailError=false"
                :placeholder="LANG.YOUR_EMAIL"
                v-model="email"
            )
            div.mt-1(v-if="showEmailError")
                a-alert(:message="showEmailErrorText" type="error" show-icon)
        div.mt-3
            | {{ LANG.MODEL_EMAIL_DESCRIPTION }}


        div.mt-3.checkbox-policy
            label
                input(type="checkbox" v-model="read_policy")
                span.text {{ LANG.READ_POLICY }}
            div.mt-1(v-if="status_agree.show")
                a-alert(:message="status_agree.text" type="error" show-icon)


        div.mt-3
            button.btn-send-email(@click="submitEmailMethod") {{ LANG.BUTTON_SEND_EMAIL }}
    a-result(
        v-else
        :status="responseSendEmail.status",
        :title="responseSendEmail.title"
        :sub-title="responseSendEmail.subTitle"
    )
        template(#extra)
            a-button(
                @click="closePopup"
            ) {{ LANG.CONTINUE_EDIT }}

</template>
<style lang="scss">
.popup-send-email {
    button {
        cursor: pointer;
    }

    .btn-send-email {
        background-color: #D8B869;
        padding: 10px 12px;
        border: none;
        width: 100%;
        border-radius: 3px;
        font-size: 16px;
    }

    .input-email {
        padding: 6px 12px;
        border: 1px solid #D8B869;
        border-radius: 3px;
        width: 100%;
    }

    .checkbox-policy {
        font-size: 16px;

        input {
            margin-right: 10px;
        }
    }
}
</style>
<script>
import {ref, onUpdated, watch, getCurrentInstance} from "vue";

export default {
    name: "NSEPopupSendEmail",
    props: {
        shownEmail: {
            type: Boolean
        }
    },

    setup(props, {emit}) {
        const spinning = ref(false)
        const email = ref('');
        const showEmailError = ref(false);
        const showEmailErrorText = ref("");

        const read_policy = ref(false);
        const send_status = ref(false)
        const responseSendEmail = ref({});

        var LANG = getCurrentInstance().appContext.config.globalProperties.LANG;
        const status_agree = ref({
            show: false,
            text: ''
        });

        const validateEmail = (email) => {
            if (!email.trim()) {
                showEmailErrorText.value = LANG.MODEL_EMAIL_IS_REQUIRE
                return false;
            }

            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var output = re.test(String(email).toLowerCase());

            if (!output) {
                showEmailErrorText.value = LANG.MODEL_EMAIL_INVALID
            } else {
                showEmailErrorText.value = ""
            }

            return output;
        }

        watch(() => read_policy.value, () => {
            if (read_policy.value) status_agree.value.show = false;
        });

        const submitEmailMethod = () => {
            if (!validateEmail(email.value)) {
                showEmailError.value = true;
            } else if (!read_policy.value) {
                status_agree.value.text = LANG.REQUIRED;
                status_agree.value.show = true;
            } else {
                spinning.value = true;
                emit('sendEmail', email.value, (resFromApi) => {
                    spinning.value = false;
                    send_status.value = true;

                    responseSendEmail.value = {
                        status: resFromApi.status,
                        title: resFromApi.title,
                        subTitle: resFromApi.sub_title,
                    }
                });
            }
        }

        const closePopup = () => {
            emit('closePopup')
        }

        onUpdated(() => {
            responseSendEmail.value = {
                status: '',
                title: '',
                subTitle: '',
            }
            send_status.value = false;
        });

        return {
            submitEmailMethod,
            spinning,
            email,
            send_status,
            responseSendEmail,
            closePopup,
            read_policy,
            showEmailError,
            showEmailErrorText,
            status_agree
        }
    }
}
</script>
